import { Component, Inject, OnInit } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheetRef } from '@angular/material/bottom-sheet';

import { CuttingButt } from '../../models/cutting/cutting-butt.model';

@Component({
  selector: 'csl-many-butt-in-color-bottom-sheet',
  templateUrl: './many-butt-in-color-bottom-sheet.component.html',
  styleUrls: ['./many-butt-in-color-bottom-sheet.component.scss'],
})
export class ManyButtInColorBottomSheetComponent implements OnInit {
  constructor(
    private bottomSheetRef: MatBottomSheetRef<ManyButtInColorBottomSheetComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: CuttingButt[]
  ) {}

  ngOnInit(): void {}

  selectButt(butt: CuttingButt): void {
    this.bottomSheetRef.dismiss(butt);
  }
}
